import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default function createStore() {
	return new Vuex.Store({
		state: {
			host: '',
			// deviceType: 'pc',
			deviceType: 'mobile',
			showDebug: false,
			adPosConfig: {
				categories: [4, 8],
				categoriesPC: [10, 20],
				ranking: [3],
				rankingPC: [6],
			},
			adsensConfig: {
				scriptUrl: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',

				home_1: {
					path: '/23334144490/chicagoyestet.com_home_1',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000426275-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				home_2: {
					path: '/23334144490/chicagoyestet.com_home_2',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000124824-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				home_3: {
					path: '/23334144490/chicagoyestet.com_home_3',
					sizes: [
						[336, 280],
						[300, 250],
					],
					id: 'div-gpt-ad-1770000176538-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				home_4: {
					path: '/23334144490/chicagoyestet.com_home_4',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000231398-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				home_5: {
					path: '/23334144490/chicagoyestet.com_home_5',
					sizes: [
						[336, 280],
						[300, 250],
					],
					id: 'div-gpt-ad-1770000273719-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				list_top: {
					path: '/23334144490/chicagoyestet.com_list_1',
					sizes: [
						[336, 280],
						[300, 250],
					],
					id: 'div-gpt-ad-1770000530010-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				categories: [
					{
						path: '/23334144490/chicagoyestet.com_list_2',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000569619-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					{
						path: '/23334144490/chicagoyestet.com_list_3',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000618637-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
				],
				ranking_top: {
					path: '/23334144490/chicagoyestet.com_rank_1',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000668866-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				ranking: [
					{
						path: '/23334144490/chicagoyestet.com_rank_2',
						sizes: [
							[336, 280],
							[300, 250],
						],
						id: 'div-gpt-ad-1770000714638-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
				],
				detail_1: {
					path: '/23334144490/chicagoyestet.com_details_1',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000757371-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				detail_2: {
					path: '/23334144490/chicagoyestet.com_details_2',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000807708-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
				chapter_1: {
					path: '/23334144490/chicagoyestet.com_read_1',
					sizes: [
						[300, 250],
						[336, 280],
					],
					id: 'div-gpt-ad-1770000854064-0',
					style: 'min-width: 300px; min-height: 250px;',
				},
			},
			domainConfig: {
				siteName: 'Web Novels',
				siteIcon: '/icon/2.svg',
				IAMEMAIL: 'contact@chicagoyestet.com',
				IAmURL: 'chicagoyestet.com',
				ABOUTUS: 'Welcome to Web Novels, the premier destination for the next generation of storytelling. We bridge the gap between advanced artificial intelligence and creative literature. Our mission is to provide readers worldwide with a boundless library of original web fiction, updated in real-time. Whether you crave epic fantasy or modern romance, Web Novels delivers fresh, high-quality narratives powered by the future of AI.',
				meta: {
					title: 'Read AI Novels Online- Endless Webnovels',
					des: 'Read the latest and most popular web novels online. Explore a vast library of AI-enhanced stories, from Fantasy to Romance. Start your immersive reading journey on Web Novels today!',
				},
				firebase: {
					apiKey: 'AIzaSyCrqnBrSUBOWkxPT3rioLG9NsMZy9HEcdk',
					authDomain: 'web-pub-5208-1.firebaseapp.com',
					projectId: 'web-pub-5208-1',
					storageBucket: 'web-pub-5208-1.firebasestorage.app',
					messagingSenderId: '352946172649',
					appId: '1:352946172649:web:937a3f597b2f22dfd3b678',
					measurementId: 'G-NFYW58DCC4',
				},
				bannerDesign: 4,
				adsense: {
					scriptUrl: 'https://securepubads.g.doubleclick.net/tag/js/gpt.js',
					list_top: {
						path: '/23334144490/chicagoyestet.com_list_1',
						sizes: [
							[336, 280],
							[300, 250],
						],
						id: 'div-gpt-ad-1770000530010-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					home_1: {
						path: '/23334144490/chicagoyestet.com_home_1',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000426275-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					home_2: {
						path: '/23334144490/chicagoyestet.com_home_2',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000124824-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					home_3: {
						path: '/23334144490/chicagoyestet.com_home_3',
						sizes: [
							[336, 280],
							[300, 250],
						],
						id: 'div-gpt-ad-1770000176538-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					home_4: {
						path: '/23334144490/chicagoyestet.com_home_4',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000231398-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					home_5: {
						path: '/23334144490/chicagoyestet.com_home_5',
						sizes: [
							[336, 280],
							[300, 250],
						],
						id: 'div-gpt-ad-1770000273719-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					categories: [
						{
							path: '/23334144490/chicagoyestet.com_list_2',
							sizes: [
								[300, 250],
								[336, 280],
							],
							id: 'div-gpt-ad-1770000569619-0',
							style: 'min-width: 300px; min-height: 250px;',
						},
						{
							path: '/23334144490/chicagoyestet.com_list_3',
							sizes: [
								[300, 250],
								[336, 280],
							],
							id: 'div-gpt-ad-1770000618637-0',
							style: 'min-width: 300px; min-height: 250px;',
						},
					],
					ranking_top: {
						path: '/23334144490/chicagoyestet.com_rank_1',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000668866-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					ranking: [
						{
							path: '/23334144490/chicagoyestet.com_rank_2',
							sizes: [
								[336, 280],
								[300, 250],
							],
							id: 'div-gpt-ad-1770000714638-0',
							style: 'min-width: 300px; min-height: 250px;',
						},
					],
					detail_1: {
						path: '/23334144490/chicagoyestet.com_details_1',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000757371-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					detail_2: {
						path: '/23334144490/chicagoyestet.com_details_2',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000807708-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
					chapter_1: {
						path: '/23334144490/chicagoyestet.com_read_1',
						sizes: [
							[300, 250],
							[336, 280],
						],
						id: 'div-gpt-ad-1770000854064-0',
						style: 'min-width: 300px; min-height: 250px;',
					},
				},
				ads_file: 'src/utils/config/adstxt/group_31.txt',
			},
			categories: [],
			categoriesLoaded: false,
			recommendList: [],
		},
		mutations: {
			setHost(state, host) {
				state.host = host
			},
			setTitle(state, title) {
				state.title = title
			},
			setDomain(state, domainConfig) {
				state.domainConfig = domainConfig
			},
			setDeviceType(state, deviceType) {
				state.deviceType = deviceType
			},
			setDebug(state, showDebug) {
				state.showDebug = showDebug
			},
			setAdsense(state, adsenseConfig) {
				state.adsensConfig = adsenseConfig
			},
			SET_CATEGORIES(state, categories) {
				state.categories = categories
				state.categoriesLoaded = true
			},
			SET_RECOMMEND_LIST(state, list) {
				state.recommendList = list
			},
			// 设置品牌列表
			SET_BRAND_LIST(state, brandList) {
				state.brandList = brandList
			},
		},
		getters: {
			showDebug: (state) => state.showDebug,
			deviceType: (state) => state.deviceType,
			host: (state) => state.host,
			adsensConfig: (state) => state.adsensConfig,
			adPosConfig: (state) => state.adPosConfig,
			domainConfig: (state) => state.domainConfig,
			// 获取所有分类
			categories: (state) => state.categories,
			// 分类是否已加载
			categoriesLoaded: (state) => state.categoriesLoaded,
			// 通过ID或value获取特定分类
			getCategoryByValue: (state) => (value) => {
				return state.categories.find((cat) => cat.value === value || cat.id === value) || null
			},
			// 获取品牌列表
			brandList: (state) => state.brandList,
			// 品牌列表是否已加载
			brandListLoaded: (state) => state.brandListLoaded,
			// 车辆列表状态
			carListState: (state) => state.carListState,
			isFromDetail: (state) => state.carListState.fromDetail,
			currentPage: (state) => state.carListState.currentPage,
			filters: (state) => state.carListState.filters,
			lastVisitedPage: (state) => state.carListState.lastVisitedPage,
			queryParams: (state) => state.carListState.queryParams,
		},
	})
}
